import VodafoneImages from "./Clients/vodafone/Images";

export const ImagesMapping: Record<string, any> = {
  vodafone: VodafoneImages
};
